<template>
  <div class="h-full">
    <section class="dashboard__header">
      <div class="container-fluid">
        <div class="dashboard__header__wrapper">
          <div class="dashboard__header__left">
            <h3 class="dashboard__header__title">{{ $lang.app.APPLICATIONS }}</h3>
          </div>
          <div class="dashboard__header__right">
            <div class="dashboard__view__switcher">
              <ul class="dashboard__view__nav nav">
                <li class="dashboard__view__item">
                  <button class="dashboard__view__link dashboard__view__grid"
                          :class="{'link__active': $store.getters.isDisplayGrid}"
                          @click="$store.dispatch('changeDisplayToGrid')">
                    <svg viewBox="0 0 24 24" width="24" height="24"><use xlink:href="@/assets/v2/img/sprite.svg#view__grid"></use></svg>
                  </button>
                </li>
                <li class="dashboard__view__item">
                  <button class="dashboard__view__link dashboard__view__list"
                          :class="{'link__active': $store.getters.isDisplayList}"
                          @click="$store.dispatch('changeDisplayToList')">
                    <svg viewBox="0 0 24 24" width="24" height="24"><use xlink:href="@/assets/v2/img/sprite.svg#view__table"></use></svg>
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="dashboard__nav">
      <div class="container-fluid">
        <ul class="dashboard__nav__list">
          <li v-for="navItem in items" :key="navItem.key"
              class="dashboard__nav__item">
            <router-link :to="{ name: navItem.route }"
                         class="dashboard__nav__link"
                         :class="{'link__active': $route.matched.some(item => item.name === navItem.route)}">
              {{ navItem.title }}<span v-if="navItem.badge" class="dashboard__nav__count">{{ navItem.badge }}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </section>
    <router-view/>
  </div>
</template>
<script>
import employeeApi from "../../../api/employee/employee";

export default {
  name: 'EmployeeApplicationsLayout',
  data() {
    return {
      items: [],
    }
  },
  created() {
    this.initItems()
    this.fetchStatistics()
  },
  methods: {
    initItems() {
      this.items = [{
        key: 'APPLICATIONS',
        title: this.$lang.app.APPLICATIONS,
        icon: "DocumentTextIcon",
        type: "link",
        route: "EmployeeApplicationsList",
        badge: false,
      }]
    },
    fetchStatistics() {
      employeeApi.statistics().then(res => {
        if(res.registrationWait) {
          this.items.push({
            key: 'WAITING_REGISTRATION',
            title: this.$lang.app.WAITING_REGISTRATION,
            icon: 'ClipboardListIcon',
            type: 'link',
            route: 'EmployeeApplicationsWaitingRegistration',
            badge: res.registrationWait,
          })
        }
        if(res.sendWait) {
          this.items.push({
            key: 'WAITING_SEND_TO_APPLICANT',
            title: this.$lang.app.WAITING_SEND_TO_APPLICANT,
            icon: 'ClipboardListIcon',
            type: 'link',
            route: 'EmployeeApplicationsWaitingSendToApplicant',
            badge: res.sendWait,
          })
        }
        if(res.onPending) {
          this.items.push({
            key: 'ON_PENDING',
            title: this.$lang.app.ON_PENDING,
            icon: 'ClipboardListIcon',
            type: 'link',
            route: 'EmployeeApplicationsOnPending',
            badge: res.onPending,
          })
        }
        if(res.onSign) {
          this.items.push({
            key: 'FOR_SIGN',
            title: this.$lang.app.FOR_SIGN,
            icon: 'PencilIcon',
            type: 'link',
            route: 'EmployeeApplicationsForSign',
            badge: res.onSign,
          })
        }
        if(res.onConfirmPayment) {
          this.items.push({
            key: 'ON_CONFIRM_PAYMENT',
            title: this.$lang.app.CONFIRM_PAYMENT,
            icon: 'PencilIcon',
            type: 'link',
            route: 'EmployeeApplicationsOnConfirmPayment',
            badge: res.onConfirmPayment,
          })
        }
        if(res.curatorCount) {
          this.items.push({
            key: 'YOU_CURATOR',
            title: this.$lang.app.YOU_CURATOR,
            icon: 'UserIcon',
            type: 'link',
            route: 'EmployeeApplicationsYouCurator',
            badge: res.curatorCount,
          })
        }
        if(res.onPendingCount) {
          this.items.push({
            key: 'TO_RESOLUTION',
            title: this.$lang.app.TO_RESOLUTION,
            icon: 'UserIcon',
            type: 'link',
            route: 'EmployeeApplicationsToResolution',
            badge: res.onPendingCount,
          })
        }
        if(res.responsibleCount) {
          this.items.push({
            key: 'YOU_RESPONSIBLE',
            title: this.$lang.app.YOU_RESPONSIBLE,
            icon: 'UserIcon',
            type: 'link',
            route: 'EmployeeApplicationsYouResponsible',
            badge: res.responsibleCount,
          })
        }
        if(res.curatorManagerCount) {
          this.items.push({
            key: 'DEPARTMENT_CURATOR',
            title: this.$lang.app.DEPARTMENT_CURATOR,
            icon: 'UserIcon',
            type: 'link',
            route: 'EmployeeApplicationsDepartmentCurator',
            badge: res.curatorManagerCount,
          })
        }
        if(res.responsibleManagerCount) {
          this.items.push({
            key: 'DEPARTMENT_RESPONSIBLE',
            title: this.$lang.app.DEPARTMENT_RESPONSIBLE,
            icon: 'UserIcon',
            type: 'link',
            route: 'EmployeeApplicationsDepartmentResponsible',
            badge: res.responsibleManagerCount,
          })
        }
        if(this.$store.getters.isRegistrator) {
          this.items.push({
            key: 'EGRZ',
            title: this.$lang.app.EGRZ,
            icon: "DocumentTextIcon",
            type: "link",
            route: "EmployeeEgrzApplicationsList",
            badge: false,
          })
        }
      })
    }
  },
  beforeMount() {
    this.$emitter.on("refreshStatistics", () => {
      this.initItems()
      this.fetchStatistics()
    });
  },
  beforeUnmount() {
    this.$emitter.off('refreshStatistics')
  }
}
</script>